/**
 * Runtime feature flags for flexium internals.
 *
 * FLEXIUM_REACTIVITY_V2=0  — Emergency rollback to V1 Proxy reactivity.
 *
 * How to disable (rollback):
 *   - Node / Vitest:  FLEXIUM_REACTIVITY_V2=0 vitest
 *   - Vite build:     define: { 'process.env.FLEXIUM_REACTIVITY_V2': '"0"' }
 *
 * Default: '1' (V2 getter/setter path — enabled after Phase 1 soak).
 *
 * The V1 Proxy path remains callable until the Task 26 soak-period deletion;
 * see `docs/superpowers/plans/2026-05-16-perf-phase1-reactivity-core.md` §Task 26
 * for the removal timeline.
 */
export const REACTIVITY_V2 = (
    typeof process !== 'undefined'
        ? (process.env.FLEXIUM_REACTIVITY_V2 ?? '1')   // default: '1' (V2)
        : '1'
) !== '0'
